import MinimaxAPI from '../../api/minimax';

export const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCloning: false,
        isDeleting: false,
    },
};

export const getters = {
    getVoices: $state => $state.records,
    getUIFlags: $state => $state.uiFlags,
};

export const actions = {
    fetchVoices: async ({ commit }) => {
        commit('setUiFlags', { isFetching: true });
        try {
            const response = await MinimaxAPI.getVoices();
            commit('setVoices', response.data);
        } catch (error) {
            // Lidar com o erro
        } finally {
            commit('setUiFlags', { isFetching: false });
        }
    },
    cloneVoice: async ({ commit, dispatch }, { file, agentBotId }) => {
        commit('setUiFlags', { isCloning: true });
        try {
            const response = await MinimaxAPI.cloneVoice(file, agentBotId);
            dispatch('fetchVoices'); // Atualiza a lista de vozes
            return response.data;
        } catch (error) {
            // Lidar com o erro
            return null;
        } finally {
            commit('setUiFlags', { isCloning: false });
        }
    },
    deleteVoice: async ({ commit, dispatch }, { voiceId, agentBotId }) => {
        commit('setUiFlags', { isDeleting: true });
        try {
            await MinimaxAPI.deleteVoice(voiceId, agentBotId);
            dispatch('fetchVoices'); // Atualiza a lista de vozes
        } catch (error) {
            // Lidar com o erro
        } finally {
            commit('setUiFlags', { isDeleting: false });
        }
    },
};

export const mutations = {
    setUiFlags($state, flags) {
        $state.uiFlags = { ...$state.uiFlags, ...flags };
    },
    setVoices($state, voicesResponse) {
        if (!voicesResponse) {
            $state.records = [];
            return;
        }
        const allVoices = Object.values(voicesResponse)
            .filter(Array.isArray)
            .flat()
            .filter(voice => voice && voice.voice_id);
        $state.records = allVoices;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
